<template>
  <div class="bg-white rounded-lg shadow p-4 text-sm">
    <!-- A div rather than a button, so the title-action slot can hold its own button -->
    <div class="w-full flex items-center justify-between text-left cursor-pointer" @click="open = !open">
      <div>
        <div class="flex items-center gap-2">
          <div class="text-base font-semibold text-dark-primary">{{ title }}</div>
          <slot name="title-action"></slot>
        </div>
        <slot name="subtitle"></slot>
      </div>
      <ChevronDownIcon class="h-5 w-5 shrink-0 text-dark-primary transition-transform" :class="{ 'rotate-180': open }" />
    </div>
    <div v-show="open">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineModel } from 'vue';
import { ChevronDownIcon } from '@heroicons/vue/20/solid';

defineProps({ title: String })
const open = defineModel('open', { default: true })
</script>
